import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../admin/AdminAuthContext";
import { useAdminData } from "../../admin/AdminDataContext";

const NAV_LINKS = [
  { to: "/admin", label: "Overview", end: true },
  { to: "/admin/events", label: "Events" },
  { to: "/admin/services", label: "Services" },
  { to: "/admin/testimonials", label: "Testimonials" },
];

function AdminLayout() {
  const { logout } = useAdminAuth();
  const { resetToServerData } = useAdminData();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  const handleReset = async () => {
    if (window.confirm("Reload all data from the server?")) {
      await resetToServerData();
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-shell">
        <header className="admin-header">
          <div className="admin-header__brand">
            <span className="admin-header__brand-peanut">PBJ</span>{" "}
            <span className="admin-header__brand-jelly">Admin</span>
          </div>
          <nav className="admin-nav" aria-label="Admin navigation">
            {NAV_LINKS.map((link) => {
              const isActive = link.end
                ? location.pathname === link.to
                : location.pathname.startsWith(link.to);
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={isActive ? "active" : undefined}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>
          <div className="admin-header__actions">
            <button type="button" className="admin-btn" onClick={handleReset}>
              Reset data
            </button>
            <button type="button" className="admin-btn admin-btn--danger" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </header>

        <main className="admin-main">
          <div className="admin-notice body-text">
            Changes are saved to the server and appear on the public site.
          </div>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
